export default __webpack_public_path__ + "static/media/bg_orange_03.a5072155.png";